import React from 'react';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import { CurrencyCode } from 'further-types/lp/vehicle';
import AdvanceSubscriptionsContent from './AdvanceSubscriptionsContent';

const TransferAdvanceSubscriptions: React.FC<{
  partnerTransferId: string;
  baseCurrency: CurrencyCode;
  onNext: () => void;
  onPrevious: () => void;
  stepper: React.ReactNode;
}> = ({ partnerTransferId, baseCurrency, onNext, onPrevious, stepper }) => {
  const { selectedVehicleId } = useLayoutContext();

  const [advanceSubscriptions] =
    api.partnerTransfers.getAdvanceSubscriptions.useSuspenseQuery(
      {
        partnerTransferId,
        vehicleId: selectedVehicleId ?? '',
      },
      {
        staleTime: 0,
        gcTime: 0,
      },
    );

  return (
    <AdvanceSubscriptionsContent
      partnerTransferId={partnerTransferId}
      advanceSubscriptions={advanceSubscriptions.map((advanceSubscription) => ({
        ...advanceSubscription,
        newInvestorBreakdown: advanceSubscription.newInvestorBreakdown ?? [],
      }))}
      baseCurrency={baseCurrency}
      onNext={onNext}
      onPrevious={onPrevious}
      stepper={stepper}
    />
  );
};

export default TransferAdvanceSubscriptions;
